import { useEffect } from "react";

/**
 * Injects a single Schema.org JSON-LD script into <head>, keyed by id.
 * On route change or data change it replaces the previous script, and it is
 * removed on unmount so stale structured data never leaks across pages.
 */
export function useJsonLd(id: string, data: object | object[] | null) {
  const serialized = data ? JSON.stringify(data) : null;

  useEffect(() => {
    if (!serialized) return;

    const scriptId = `jsonld-${id}`;
    let script = document.getElementById(scriptId) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = scriptId;
      document.head.appendChild(script);
    }
    script.textContent = serialized;

    return () => {
      script?.remove();
    };
  }, [id, serialized]);
}